import * as t from './actionTypes';
import { fetchEventsLogResponse } from './actions';
import type { EventsLogReduxState } from './types';

type EventsLogReducerAction = ReturnType<typeof fetchEventsLogResponse>;

export const initialState: EventsLogReduxState['insights']['events'] = {
  eventsLog: [],
};

export const eventsLogReducer = (state = initialState, action: EventsLogReducerAction) => {
  switch (action.type) {
    case t.FETCH_EVENTS_LOG_RESPONSE: {
      return {
        ...state,
        eventsLog: action.response,
      };
    }
    default: {
      return state;
    }
  }
};
